import { Box, Button, Typography, Dialog, DialogTitle, DialogActions } from "@mui/material";
import { UnpublishedRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
type UnpublishDialogProps = {
  onClose: () => void;
  onConfirm: () => void;
  itemName: string;
  loading: boolean;
};
export const UnpublishDialog = ({
  onClose,
  onConfirm,
  itemName,
  loading
}: UnpublishDialogProps) => {
  const {
    t
  } = useTranslation();
  return <Dialog open fullWidth maxWidth={"xs"} onClose={onClose} data-cy="unpublishDialog" data-sentry-element="Dialog" data-sentry-component="UnpublishDialog" data-sentry-source-file="UnpublishDialog.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="UnpublishDialog.tsx">
        <Box sx={{
        backgroundColor: "red.100",
        borderRadius: "100%",
        width: "40px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }} data-sentry-element="Box" data-sentry-source-file="UnpublishDialog.tsx">
          <UnpublishedRounded color="error" data-sentry-element="UnpublishedRounded" data-sentry-source-file="UnpublishDialog.tsx" />
        </Box>
        <Typography variant="h5" sx={{
        mt: 1.5
      }} data-sentry-element="Typography" data-sentry-source-file="UnpublishDialog.tsx">
          <Typography variant="inherit" display="inline" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="UnpublishDialog.tsx">
            {t("content.itemEditUnpublishContentItemTitle")}
            {":"}
          </Typography>{" "}
          {itemName}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{
        mt: 1
      }} data-sentry-element="Typography" data-sentry-source-file="UnpublishDialog.tsx">
          {t("content.itemEditUnpublishDescription")}
        </Typography>
      </DialogTitle>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="UnpublishDialog.tsx">
        <Button color="inherit" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="UnpublishDialog.tsx">
          {t("common.cancel")}
        </Button>
        <Button data-cy="ConfirmUnpublishButton" variant="contained" color="error" aria-label={t("content.itemEditUnpublishItem")} onClick={onConfirm} loading={loading} data-sentry-element="Button" data-sentry-source-file="UnpublishDialog.tsx">
          {t("content.itemEditUnpublishItem")}
        </Button>
      </DialogActions>
    </Dialog>;
};